import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-bed",
  "use": "icon-si-glyph-bed-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-bed\" id=\"icon-si-glyph-bed\"><title>829</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 5.000000)\" fill=\"#434343\"><path d=\"M15.031,2.016 L15.031,3.031 L1.938,3.031 L1.938,0.078 L0.009,0.078 L0.009,3.031 L0.009,5.246 L0.009,5.971 L1.938,5.971 L1.938,4.938 L15.031,4.938 L15.031,5.971 L15.969,5.971 L15.969,2.016 L15.031,2.016 Z\" class=\"si-glyph-fill\" /><ellipse cx=\"3.985\" cy=\"0.97\" rx=\"0.985\" ry=\"0.97\" class=\"si-glyph-fill\" /><path d=\"M13.991,1.998 L6.013,1.998 L6.013,1.132 C6.013,0.534 6.656,0.049 7.447,0.049 L12.556,0.049 C13.349,0.049 13.991,0.534 13.991,1.132 L13.991,1.998 L13.991,1.998 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-bed.svg
// module id = 5Ixz
// module chunks = 62